// This is a modal for Signupreferrerindiviualone

import { Button as AIMEButton } from "tot-loft-component-library";

import styled from "@emotion/styled";
import Terms from "./Terms";

export default function ModalSignupreferrerindiviualone({ onClose }) {
  return (
    <TermsAndCondtions>
      <Left>
        <Frame58>
          <Terms />
          <Frame59>
            {/* <AIMEButton
              size="small"
              onClick={() => onClose()}
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
                alignItems: "center",
                flex: "none",
                borderRadius: "999px",
                background: "rgb(241, 245, 249)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "center",
                boxSizing: "border-box",
                padding: "16px 32px",

                "@media (max-width: 600px)": {
                  width: "100%",
                },
              }}
            >
              <span
                style={{
                  color: "rgb(33, 37, 67)",
                  textOverflow: "ellipsis",
                  fontSize: "16px",
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: "600",
                  lineHeight: "110%",
                  textAlign: "left",
                }}
              >
                Clear
              </span>
            </AIMEButton> */}
{/* 
            <AIMEButton
              size="small"
              onClick={() => onClose()}
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
                alignItems: "center",
                flex: "none",
                gap: "8px",
                borderRadius: "999px",
                width: "250px",
                height: "50px",
                background: "rgb(97, 98, 197)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "center",
                boxSizing: "border-box",
                padding: "16px 32px",

                "@media (max-width: 600px)": {
                  width: "100%",
                },
              }}
            >
              <span
                style={{
                  color: "white",
                  textOverflow: "ellipsis",
                  fontSize: "16px",
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: "600",
                  lineHeight: "110%",
                  textAlign: "left",
                  margin:"0px"
                }}
              >
                I Agree
              </span>
            </AIMEButton> */}
          </Frame59>
        </Frame58>
      </Left>
    </TermsAndCondtions>
  );
}

const RootWrapperModalSignupreferrerindiviualone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;

  box-sizing: border-box;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  border-radius: 32px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 40px 24px 24px;
`;

const TermsAndCondtions = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  max-width: 912px;
  width: 100%;
  box-sizing: border-box;
  padding: 24px;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  max-width: 912px;
  width: 100%;
  box-sizing: border-box;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const TermsConditions = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Introduction = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame59 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  gap: 16px;

  @media (max-width: 600px) {
    flex-direction: column-reverse;
  }
`;
